<template>
    <table class="table table-sm border">
        <template v-for="(t,i) in ($safe(row,'EDTs') || [])">
            <tr>
                <td rowspan="2" class="p-25 border-right">
                    <div class="d-flex flex-column g-25">
                        <button v-on:click="$emit('action','title-edit',row,t)" class="btn btn-sm btn-icon btn-flat-danger">
                            <feather-icon icon="Edit2Icon"></feather-icon>
                        </button>
                        <button v-on:click="$emit('action','title-delete',row,t)" class="btn btn-sm btn-icon btn-flat-secondary">
                            <feather-icon icon="TrashIcon"></feather-icon>
                        </button>
                    </div>
                </td>
                <td :class="['text-nowrap',i == 0 ? 'border-0' : 'border-top-3','w-34',{'bg-light-secondary':!$safe(t,'TitleEndDateStr') && $safe(t,'Active')}]">
                    <small>Unvan</small>
                    <div class="font-weight-bolder">{{ $safe(t,'EmployeeDepartmentTitle.Name') || '-' }}</div>
                </td>
                <td :class="['text-nowrap',i == 0 ? 'border-0' : 'border-top-3','w-33']">
                    <small>Başlangıç Tarihi</small>
                    <div class="font-weight-bolder">{{ $safe(t,'TitleStartDateStr') || '-' }}</div>
                </td>
                <td :class="['text-nowrap',i == 0 ? 'border-0' : 'border-top-3','w-33']">
                    <small>Bitiş Tarihi</small>
                    <div class="font-weight-bolder">{{ $safe(t,'TitleEndDateStr') || '-' }}</div>
                </td>
            </tr>
            <tr>
                <td colspan="3">
                    <small :class="$safe(t,'TitleEndDateStr') ? 'text-muted' : 'text-secondary'">{{ text($safe(t,'EmployeeDepartmentTitle.Name'),$safe(t,'TitleStartDateStr'),$safe(t,'TitleEndDateStr')) }}</small>
                </td>
            </tr>
        </template>
    </table>
</template>

<script>
export default {
    props:{
        row:Object,
        field:Object
    },
    methods:{
        text(t,s,e){
            if(s){
                if(e){
                    return `[${t || '-'}] unvanına (${s}) tarihinde atanmış, (${e}) tarinde ataması kaldırılmıştır.`
                }else return `[${t || '-'}] unvanına (${s}) tarihinde atanmış ve hala bu unvanı kullanmaktadır.`
            }else return null
        }
    }
}
</script>

<style>
.border-top-2{
    border-top: 2px ;
}
</style>